import { HTTP } from '../../shared/http-common';
import { PW_VALIDATOR } from '../../shared/password-validation';

export default {
    name: 'PasswordReset',
    data() {
        return {
            uuid: this.$route.query.uuid,
            token: this.$route.query.token,
            scope: this.$route.query.scope,
            newPassword: null,
            reenteredPassword: null,
            passwordResetStatusMessage: null,
            passwordResetStatusSuccess: false,
            isBusy: false,
            validationResultsError: null,
        };
    },
    computed: {
        invalidPassword: function () {
            if (this.newPassword != null) {
                var validationResult = PW_VALIDATOR.passwordIsValid(this.newPassword)
                this.validationResultsError = validationResult.error;
                return !validationResult.isValid;
            }

            return false;
        },

        passwordsDontMatch: function () {
            if (this.newPassword != null && this.reenteredPassword != null) {
                return this.newPassword !== this.reenteredPassword;
            }

            return false;
        },
    },
    methods: {
        resetPassword(e) {
            if (!this.invalidPassword) {
                this.resetPasswordRequest(process.env.BASE_URL + this.uuid + '/confirmPasswordReset/' + this.token);
            }
        },

        resetPasswordRequest(url) {
            this.isBusy = true;
            HTTP.post(url, this.newPassword, {
                headers: { 'Content-Type': 'text/plain', 'X-Odm-Scope': this.scope},
            })
                .then(response => {
                    this.isBusy = false;

                    if (response.status !== 204) {
                        this.displayPasswordChangeStatus(false, response.data)
                    } else {
                        this.displayPasswordChangeStatus(true)
                        this.newPassword = null;
                        this.reenteredPassword = null;
                    }
                    this.isBusy = false;
                })
                .catch(error => {
                    this.displayPasswordChangeStatus(false, error.response.data);
                    this.isBusy = false;
                });
        },

        displayPasswordChangeStatus(success, errorMessageData) {
            this.passwordResetStatusSuccess = success;
            var message = success ? "Password reset performed successfully" : "There was an error resetting the password. Reason: "
            this.passwordResetStatusMessage = (errorMessageData ? message + errorMessageData.message : message) + ". ";
            if (errorMessageData != null && errorMessageData.hasOwnProperty('details') && errorMessageData.details.length > 0) {
                this.  passwordResetStatusMessage += errorMessageData.details[0].message;
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/PasswordReset/PasswordReset.js